// Which kind of private office the visitor wants to see: serviced (flexible,
// operator-run) or conventional (lease space listed by real-estate brokers).
// Absent means "All".
export const officeTypeFilterQueryParam = "po-office-type";

// The values as they appear in the URL. Lowercase so a shared link reads
// naturally (`?po-office-type=conventional`).
export const officeTypeFilterValues = ["serviced", "conventional"] as const;
export type TOfficeTypeFilterValue = (typeof officeTypeFilterValues)[number];

// Mirrors the backend `OfficeType` enum.
export const officeTypeServiced = "SERVICED";
export const officeTypeConventional = "CONVENTIONAL";
export type TOfficeType =
    | typeof officeTypeServiced
    | typeof officeTypeConventional;

const officeTypeByFilterValue: Record<TOfficeTypeFilterValue, TOfficeType> = {
    serviced: officeTypeServiced,
    conventional: officeTypeConventional,
};

/**
 * The backend office type a filter value from the URL selects, or null when the
 * value is absent or not one we know ("All").
 */
export const officeTypeForFilterValue = (
    value: string | null | undefined
): TOfficeType | null =>
    (officeTypeFilterValues as readonly string[]).includes(value ?? "")
        ? officeTypeByFilterValue[value as TOfficeTypeFilterValue]
        : null;

/**
 * The office type of a private office option. Every real option carries one,
 * but a location without real options is represented by a synthesized generic
 * group that has none -- those are flexible operators, so they count as
 * serviced, as does anything sent before the field existed.
 */
export const effectiveOfficeType = (
    officeType: string | null | undefined
): TOfficeType =>
    officeType === officeTypeConventional
        ? officeTypeConventional
        : officeTypeServiced;
